//MANUALY SYNC TO DEFAULT.SCSS

export const lightest = "#fff";
export const lighter = "#fbfbfb";
export const light = "#D9D9D9";
export const dark = "#304060";
export const darkest = "#070721"
export const primary = "#2e8ffa";
export const grayText = "#757575"

export const sucess = "#51C47C"
export const danger = "#ff5d5d"
export const warning = "#FFB41F"


export const primaryOpacity = "rgba(46, 143, 250, 0.075)";
export const darkOpacity = "rgba(46, 143, 250, 0.024)";
export const opacityText = "rgba(235,236,240,.74)";
export const inputOpacity = "rgba(0, 0, 0, 0.10)";

export const defaultShadow = "0 4px 8px 0 rgba(46, 145, 250, 0.06), 0 6px 11px 0 rgba(46, 145, 250, 0.08)";

export default {
    light, lighter, lightest, dark, primary, darkest, primaryOpacity, darkOpacity,
    opacityText, defaultShadow, inputOpacity, grayText, sucess, danger, warning
}